define 'controller/NavigationController', ['jquery', 'custom/media-query'], ($, mq) ->
  class Navigation

    constructor: (@$el) ->
      container = @$el
      self = this

      $(container).on 'mouseenter', '.navigation:not(.active) .navigation__list__item--mainCategory', (e) ->
        if $(@).hasClass('navigation__list__item--mainCategory--no-flyout')
          return
        $(@).find('.sub-navigation__list__flyout').stop().fadeIn(0.1)
 
      $(container).on 'mouseleave', '.navigation:not(.active) .navigation__list__item--mainCategory', (e) ->
        if $(@).hasClass('navigation__list__item--mainCategory--no-flyout')
          return
        $(@).find('.sub-navigation__list__flyout').stop().fadeOut(0.1)

      $(container).on 'click', '.navigation__close', (e) ->
        $(@).closest('.sub-navigation__list__flyout').stop().fadeOut(0.1)
 
      $(container).on 'click', '.mobile-navigation__open', (e) ->
        $('.navigation').addClass('active')
        $('.navigation__list__close').addClass('active')
        $('body').addClass('navOpen')
        $('.darkOverlay').addClass('active')

      $(container).on 'click', '.navigation__list__close', (e) ->
        $('.navigation').removeClass('active')
        $('.navigation__list__close').removeClass('active')
        $('body').removeClass('navOpen')
        $('.darkOverlay').removeClass('active')

      $(container).on 'click', '.js-close-mobilenav', (e) ->
        $('.navigation').removeClass('active')
        $('.navigation__list__close').removeClass('active')
        $('body').removeClass('navOpen')
        $('.darkOverlay').removeClass('active')

      $('.darkOverlay').on 'click', (e) ->
        $('.navigation').removeClass('active')
        $('.navigation__list__close').removeClass('active')
        $('body').removeClass('navOpen')
        $('.darkOverlay').removeClass('active')

      $(container).on 'click', '.navigation.active .navigation__list__item--mainCategory a.hasChildren, .navigation.active .navigation__list__item--mainCategory span.hasChildren', (e) ->
        e.preventDefault()
        if $(@).closest('[data-navigation]').data('navigation') == 'right'
          $('.navigation__list.navigation__list--left').hide()
        $(@).parent().find('.sub-navigation__list__flyout').addClass('selected')
        $(@).closest('.navigation__inner').addClass('selected')

      $(container).on 'click', '.navigation.active .sub-navigation__list__flyout--childCategory a.hasChildren, .navigation.active .sub-navigation__list__flyout--childCategory span.hasChildren', (e) ->
        e.preventDefault()
        $(@).toggleClass('active')
        $(@).next().slideToggle('slow')

      $(container).on 'click', '.sub-navigation__list__flyout--back', (e) ->
        $('.navigation__list.navigation__list--left').show()
        $(@).closest('.navigation__inner').removeClass('selected')
        setTimeout (->
          $('.sub-navigation__list__flyout').removeClass('selected')
        ), 500

      $(container).on 'click', '.sub-navigation__list__flyout--categoryName', (e) ->
        if $(@).hasClass('js-link')
          window.location = window.atob($(@).data('url'))
        else
          window.location =  $(@).data('url')

      if !$("body").hasClass("full-width")
        $('.sub-navigation__list__flyout').css('width', $('.pagecontent').width())

        $(window).on 'resize', (e) ->
          $('.sub-navigation__list__flyout').css('width', $('.pagecontent').width())

      $('.navigation').on 'click', '.js-link', (e) ->
        target = $(e.currentTarget).data('url')
        if(target.length)
          e.preventDefault()
          window.location = window.atob(target)
          return